import React from "react";
import Footer from "./Footer";
import { useLanguage } from "../i18n/LanguageContext";

function Download() {
  const { t } = useLanguage();

  return (
    <section id="download" className="download-section">
      <div className="download-content">
        <img className="logo" src="/assets/icon.png" alt="TicketBox" />
        <h2>{t.download.title}</h2>
        <p>{t.download.description}</p>
        <div className="download-links">
          <a
            href="https://play.google.com/store/apps/details?id=com.ygalaad.ticketbox"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/assets/googlestore.png" alt={t.download.badgeAlt} />
          </a>
        </div>
      </div>
      <Footer />
    </section>
  );
}

export default Download;
